import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

const READER = { width: "calc(100% - 32px)", maxWidth: "820px", marginInline: "auto", boxSizing: "border-box" };
const LINK = "text-brand-red font-bold hover:underline";

const EN = {
    en: { title: "Privacy Policy", p1: "Respecting privacy is one of the working principles of the {siteName} website, including handling the correspondence and requests it receives with care and responsibility.", p2a: "For privacy-related enquiries and remarks, please get in touch via the ", link: "Contact us", p2b: " page." },
    es: { title: "Política de privacidad", p1: "El respeto a la privacidad es uno de los principios de trabajo del sitio {siteName}, e incluye tratar con cuidado y responsabilidad la correspondencia y las solicitudes que recibe.", p2a: "Para consultas y observaciones sobre privacidad, escríbenos a través de la página ", link: "Contacto", p2b: "." },
    nl: { title: "Privacybeleid", p1: "Respect voor privacy is een van de werkprincipes van de website {siteName}, inclusief het zorgvuldig en verantwoord omgaan met ontvangen correspondentie en verzoeken.", p2a: "Voor vragen en opmerkingen over privacy kunt u contact opnemen via de pagina ", link: "Contact", p2b: "." },
};

export default function PrivacyPage() {
    const { lang, t } = useLang();
    useEffect(() => { document.title = `${t("privacyPolicy")} | ${t("siteName")}`; }, [t]);
    if (lang !== "ar") {
        const c = EN[lang] || EN.en;
        return (
            <article dir="ltr" className="py-10">
                <div style={READER}>
                    <h1 className="font-display font-black text-3xl md:text-4xl text-brand-black dark:text-gray-100 mb-6" data-testid="privacy-title">{c.title}</h1>
                    <div className="prose-ar text-gray-700 dark:text-gray-300 leading-[1.9] space-y-4">
                        <p data-testid="privacy-intro">{c.p1.replace("{siteName}", t("siteName"))}</p>
                        <p data-testid="privacy-intro-contact">{c.p2a}<Link to={`/${lang}/contact`} className={LINK} data-testid="privacy-contact-link">{c.link}</Link>{c.p2b}</p>
                    </div>
                </div>
            </article>
        );
    }
    return (
        <article dir="rtl" className="py-10">
            <div style={READER}>
                <h1 className="font-display font-black text-3xl md:text-4xl text-brand-black dark:text-gray-100 mb-6" data-testid="privacy-title">سياسة الخصوصية</h1>
                <div className="prose-ar text-gray-700 dark:text-gray-300 leading-[1.9] space-y-4">
                    <p data-testid="privacy-intro">احترام الخصوصية من مبادئ العمل في موقع {t("siteName")}، ويشمل التعامل بعناية ومسؤولية مع المراسلات والطلبات الواردة إليه.</p>
                    <p data-testid="privacy-intro-contact">للاستفسارات والملاحظات المتعلقة بالخصوصية، يرجى التواصل عبر صفحة <Link to="/contact" className={LINK} data-testid="privacy-contact-link">تواصل معنا</Link>.</p>
                </div>
            </div>
        </article>
    );
}
